<template>
  <section v-on:click="sectionClicked">
    <Header ref="header" :class="{scrolled: scrolled}"/>
    <div class="loadingFull" v-if="loading"></div>
    <Page :page="page" :breadcrumb="false"/>
    <Footer/>
    <WelcomeDialog ref="welcomeDialog"/>
  </section>
</template>

<script>
import Header from '@/components/Header.vue';
import Page from '@/components/Page.vue';
import Footer from '@/components/Footer.vue';
import WelcomeDialog from '@/components/WelcomeDialog.vue';

export default {
  name: 'home',
  components: {
    Header,
    Page,
    Footer,
    WelcomeDialog,
  },
  data() {
    return {
      loading: true,
      scrolled: false,
      page: null,
    };
  },
  computed: {},
  methods: {
    doNothing() {},
    sectionClicked() {
      if (this.$refs.header) this.$refs.header.headerClicked();
    },
    docScrolled() {
      this.scrolled = (window.pageYOffset >= 30);
    },
  },
  created() { document.addEventListener('scroll', this.docScrolled); },
  destroyed() { document.removeEventListener('scroll', this.docScrolled); },
  mounted() {
    /**
     * Validate language
     *
     */
    if (!this.$route.params.lang) {
      // let langCode = window.navigator.userLanguage || window.navigator.language;
      // langCode = (langCode.indexOf('id') >= 0) ? 'id' : 'en';
      // const countryCode = (langCode === 'id') ? 'id' : 'us';
      // window.location.href = `/${langCode}-${countryCode}`;
      window.location.href = '/id-id';
      return;
    }

    const langCode = this.$route.params.lang;
    const lang = langCode === 'id-id' ? 'id' : 'en';

    /**
     * Get dialog
     *
     */
    this.$http.get(this.$config.uri('config/section/dialog')).then((r) => {
      const dialog = r.data.status === 200 ? r.data.data : null;
      if (!dialog || !dialog.displayDialog) return;
      let dialogExpiry;
      const dialogExpiryStr = localStorage.getItem(`icel_dialog_expiry_${lang}`);
      if (dialogExpiryStr) {
        try {
          dialogExpiry = JSON.parse(dialogExpiryStr);
        } catch (err) {
          console.error(err); // eslint-disable-line
        }
      }
      if (dialogExpiry && dialogExpiry.id === dialog.dialogId
        && Math.floor(Date.now() / 1000) < parseInt(dialogExpiry.expiry, 10)) {
        return;
      }
      this.$refs.welcomeDialog.open(dialog);
      const d = new Date();
      if (dialog.dialogExpiry) d.setMinutes(d.getMinutes() + dialog.dialogExpiry);
      const dialogLocalData = {
        expiry: Math.floor(d.getTime() / 1000),
        id: dialog.dialogId,
      };
      localStorage.setItem(`icel_dialog_expiry_${lang}`, JSON.stringify(dialogLocalData));
    });

    /**
     * Get main page
     *
     */
    this.$http.get(this.$config.uri('page/main')).then((r) => {
      this.loading = false;
      this.page = r.data.status === 200 ? r.data.data : null;
    });
  },
};
</script>

<style scoped lang="scss">
</style>
